import { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useTokenStore } from '~entities/studios/model/token-store';
import { useUserTokenStore } from '~entities/users/model/token-store';
import { getCurrentStudio } from '~entities/studios/model/studio-store';
import { toast } from 'sonner';

export const useLogout = () => {
  const navigate = useNavigate();

  const logout = useCallback(() => {
    const currentStudio = getCurrentStudio();

    // Clear Zustand stores (this will also update axios headers via subscriptions)
    useTokenStore.setState({ token: null });
    useUserTokenStore.setState({ token: null });

    // Remove Zustand persist storage keys from localStorage
    localStorage.removeItem('token-storage');
    localStorage.removeItem('user-token-storage');

    // Navigate to login page
    void navigate({ to: '/login', search: { id: currentStudio?.locationId ?? '' } });
    toast.success('You\'ve been logged out successfully');
  }, [navigate]);

  return logout;
};
